import styled from "styled-components";
import {
    Breadcrumbs as MuiBreadcrumbs,
    Button as MuiButton,
    Card as MuiCard,
    CardContent as MuiCardContent,
    CardActionArea as MuiCardActionArea,
    Chip as MuiChip,
    CircularProgress as MuiCircularProgress,
    Divider as MuiDivider,
    FormControl as MuiFormControl,
    LinearProgress as MuiLinearProgress,
    Paper as MuiPaper,
    TextField as MuiTextField,
    Typography as MuiTypography, Box
} from "@material-ui/core";
import { ArrowBackIos } from "@material-ui/icons"
import { spacing, SpacingProps } from "@material-ui/system";

import { green, orange, red } from "@material-ui/core/colors";
import { NavLink as RouterNavLink, useHistory } from "react-router-dom";
import { MuiButtonSpacingType } from "../../types/types";
import React from "react";
import Link from "@material-ui/core/Link";
import { Alert as MuiAlert } from "@material-ui/lab";
import {Trans, useTranslation} from "react-i18next";

export const Card = styled(MuiCard)(spacing);

export const CardContent = styled(MuiCardContent)`
  ${spacing};
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
`;

export const CardActionArea = styled(MuiCardActionArea)`
  ${spacing};
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
`;

interface TypographyPropsType extends SpacingProps {
    component?: string
}

export const Typography = styled(MuiTypography)<TypographyPropsType>`
  white-space: pre-line;
  ${spacing}
`;


export const Divider = styled(MuiDivider)(spacing);

export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

export const Paper = styled(MuiPaper)(spacing);

export interface ChipPropstype extends SpacingProps {
    shipped?: boolean
    processing?: boolean
    cancelled?: boolean
}

export const Chip = styled(MuiChip)<ChipPropstype>`
  ${spacing};

  background: ${props => props.shipped && green[500]};
  background: ${props => props.processing && orange[700]};
  background: ${props => props.cancelled && red[500]};
  color: ${props => props.theme.palette.common.white};
`;

export const Spacer = styled.div`
  flex: 1 1 100%;
`;

export const ToolbarTitle = styled.div`
  min-width: 300px;
`;


export const Centered = styled.div`
    display: flex;
    justify-content: center;
`;

export const CircularProgress = styled(MuiCircularProgress)(spacing);

export const LinearProgress = styled(MuiLinearProgress)(spacing);

export const Button = styled(MuiButton)<SpacingProps | MuiButtonSpacingType>(spacing);

export const FormControl = styled(MuiFormControl)<SpacingProps>(spacing);

export const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

export const Alert = styled(MuiAlert)(spacing);

export const FlexRowSpaceBetween = (props: { children: any, maxWidth?: string | number, style?: any}) => {
    return <div style={{
        display: "flex", justifyContent: "space-between", maxWidth: props.maxWidth,
        alignItems: "center",
        ...(props.style || {}) }}
    >
        {props.children}
    </div>
};


export const FlexRowStart = (props: { children: any, style?: any }) => {
    return <div style={{ display: "flex", ...(props.style || {})  }}>
        {props.children}
    </div>
};

export const FlexRowEnd = (props: { children: any, style?: any }) => {
    return <div style={{ display: "flex", justifyContent: "flex-end", ...(props.style || {})  }}>
        {props.children}
    </div>
};


export const Space = (props: { size: number }) => {
    return <div style={{ minHeight: props.size * 4 }}/>
};

export const BackButton = (props: { to?: string, title?: string }) => {
    const history = useHistory();
    const {i18n, t} = useTranslation(["general"]);
    const locale = i18n.language;
    return <>
        <FlexRowStart>
            {props.to ? <Link to={props.to} component={RouterNavLink}>
                    <ArrowBackIos color="primary"/>
                    <span style={{ position: "relative", top: -7, left: -2, color: "#1e88e5", textDecoration: "none" }}>
                    {props.title || t("general:back")}
                </span>
                </Link>
                :
                <Button color="primary" onClick={() => history.goBack()}>
                    <ArrowBackIos color="primary"/>
                    <span style={{ position: "relative",  left: -2, color: "#1e88e5", textDecoration: "none" }}>
                        {props.title || t("general:back")}
                    </span>
                </Button>
            }
        </FlexRowStart>
        <Space size={3}/>

    </>
};



interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: any;
    value: any;
}

export const  TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
               children
            )}
        </div>
    );
}
